<template>
	<Layout class="HomeMobile">
		<Header :class="['nav-header',showNavBar?'nav-header-show':'nav-header-hidden']" slot="header"/>
		<nav ref="navBar" class="nav"/>
		<button @click="navToIfreeGroupPage" class="faq fs16 fw700">
			<svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
				<mask id="path-2-inside-1" fill="white">
					<path fill-rule="evenodd" clip-rule="evenodd"
						  d="M29.8094 23.4607C30.621 21.6149 31.0715 19.5744 31.0715 17.4287C31.0715 9.14444 24.3558 2.42871 16.0715 2.42871C7.78726 2.42871 1.07153 9.14444 1.07153 17.4287C1.07153 25.713 7.78726 32.4287 16.0715 32.4287C18.8729 32.4287 21.495 31.6607 23.7386 30.3239L31.3065 31.0807C31.6061 31.1106 31.8424 30.8305 31.7623 30.5402L29.8094 23.4607Z"/>
				</mask>
				<path
					d="M29.8094 23.4607L27.4555 22.4257L27.0873 23.2629L27.3305 24.1446L29.8094 23.4607ZM23.7386 30.3239L23.9945 27.7652L23.1508 27.6808L22.4224 28.1149L23.7386 30.3239ZM31.3065 31.0807L31.0507 33.6393L31.0507 33.6393L31.3065 31.0807ZM31.7623 30.5402L29.2835 31.2241L29.2835 31.2241L31.7623 30.5402ZM28.5001 17.4287C28.5001 19.2113 28.1264 20.8999 27.4555 22.4257L32.1633 24.4958C33.1156 22.33 33.643 19.9375 33.643 17.4287H28.5001ZM16.0715 5.00014C22.9356 5.00014 28.5001 10.5646 28.5001 17.4287H33.643C33.643 7.72428 25.776 -0.142715 16.0715 -0.142715V5.00014ZM3.64296 17.4287C3.64296 10.5646 9.20742 5.00014 16.0715 5.00014V-0.142715C6.3671 -0.142715 -1.49989 7.72428 -1.49989 17.4287H3.64296ZM16.0715 29.8573C9.20742 29.8573 3.64296 24.2928 3.64296 17.4287H-1.49989C-1.49989 27.1331 6.3671 35.0001 16.0715 35.0001V29.8573ZM22.4224 28.1149C20.5658 29.2211 18.3969 29.8573 16.0715 29.8573V35.0001C19.349 35.0001 22.4242 34.1004 25.0549 32.5329L22.4224 28.1149ZM31.5624 28.522L23.9945 27.7652L23.4828 32.8825L31.0507 33.6393L31.5624 28.522ZM29.2835 31.2241C28.8832 29.7729 30.0646 28.3722 31.5624 28.522L31.0507 33.6393C33.1477 33.849 34.8016 31.888 34.2412 29.8564L29.2835 31.2241ZM27.3305 24.1446L29.2835 31.2241L34.2412 29.8564L32.2882 22.7769L27.3305 24.1446Z"
					fill="white" mask="url(#path-2-inside-1)"/>
				<path
					d="M16.3016 9.73828C14.7794 9.73828 13.5862 10.1703 12.7016 11.0343C11.7965 11.8983 11.3645 13.0914 11.3645 14.6137H13.7096C13.7096 13.7291 13.8742 13.0503 14.2239 12.5771C14.6354 12.0217 15.2731 11.7543 16.1576 11.7543C16.8571 11.7543 17.4125 11.9394 17.8034 12.3303C18.1736 12.7211 18.3794 13.256 18.3794 13.9349C18.3794 14.4491 18.1942 14.9429 17.8239 15.3954L17.5771 15.6834C16.2399 16.8766 15.4376 17.7406 15.1702 18.296C14.8822 18.8514 14.7588 19.5303 14.7588 20.312H17.1245C17.1245 19.8183 17.2274 19.3657 17.4331 18.9543C17.6182 18.584 17.8856 18.2343 18.2559 17.9463C19.2434 17.0823 19.8399 16.5269 20.0251 16.3211C20.5188 15.6629 20.7862 14.8194 20.7862 13.7909C20.7862 12.536 20.3748 11.5486 19.5519 10.8286C18.7291 10.088 17.6388 9.73828 16.3016 9.73828ZM15.9314 21.608C15.4788 21.608 15.1085 21.752 14.8205 22.04C14.4914 22.328 14.3474 22.6983 14.3474 23.1509C14.3474 23.6034 14.4914 23.9737 14.8205 24.2617C15.1085 24.5497 15.4788 24.7143 15.9314 24.7143C16.3839 24.7143 16.7542 24.5703 17.0834 24.2823C17.3714 23.9943 17.5359 23.6034 17.5359 23.1509C17.5359 22.6983 17.3714 22.328 17.0834 22.04C16.7748 21.752 16.3839 21.608 15.9314 21.608Z"
					fill="white"/>
			</svg>
		</button>
		<a class="to-top fs16 fw700" href="#">
			<svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.21436 14.4286L13.5001 5L23.7858 14.4286" stroke="white" stroke-width="3.42857"
					  stroke-linejoin="round"/>
			</svg>
		</a>
		<section class="floor0 pt16 pl24 pr24">
			<div class="shine-1 anim-shine">
				<div class="shine-point"></div>
			</div>
			<div class="shine-2 anim-shine-2">
				<div class="shine-point"></div>
			</div>
			<div class="shine-3 anim-shine">
				<div class="shine-point"></div>
			</div>
			<img class="mt88 mb24 h40" src="../../../src/assets/imgs/home/MOGO_T1.png" alt="" style="height: 0.35rem;">
			<div class="pb8 fs16">{{ $t('header_slogon_1_m') }}</div>
			<div class="fs16">{{ $t('header_slogon_2_m') }}</div>
			<img class="h325 pl40 mt32" v-if="this.$i18n.locale==='zh-CN'"
				 src="../../../src/assets/imgs/home/phone&t1.png" alt="">
			<img class="h325 pl40 mt24" v-if="this.$i18n.locale==='en-US'"
				 src="../../../src/assets/imgs/home/phone&t1_en.png" alt="">
			<div id="product-component-1595415704699" class="mt40"></div>
			<iframe class="video-tracker" width="320" height="180" src="https://www.youtube-nocookie.com/embed/RI_NjVIIrYM"
					frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen></iframe>
		</section>
		<section class="floor1">
			<div class="max-w250">
				<div class="pb16 fs22 lh1x4 fw700" v-html="$t('global_title')"></div>
				<div class="fs14 mb40">{{ $t('global_text') }}</div>
			</div>
			<img ref="earthImg" src="../../../src/assets/imgs/home/earth.png" alt="" class="locate-pic">
		</section>
		<section class="floor2">
			<div class="content max-w250 mt80">
				<div class="fs22 lh1x4 fw700 pb8" v-html="$t('locate_title')"></div>
				<div class="fs14 pb16">{{ $t('locate_text') }}</div>
				<img src="../../../src/assets/imgs/home/satellite.jpg" alt="" class="w210 mb16 picBorderRadius">
			</div>
			<div class="pic-gps">
				<img ref="gpsBgImg" src="../../../src/assets/imgs/home/GPS_bg.png" alt="" class="gps-bg">
			</div>
		</section>
		<section class="floor3">
			<div class="content max-w250">
				<div class="mt100 fs22 lh1x4 fw700 pb8" v-html="$t('bluetooth_title')"></div>
				<div class="fs14 pb16">{{ $t('bluetooth_text') }}</div>
				<img src="../../../src/assets/imgs/home/bluetooth.jpg" alt="" class="w210 mb16 picBorderRadius">
			</div>
		</section>
		<section class="floor4">
			<div class="max-w250">
				<div class="fs22 lh1x4 fw700 pb24" v-html="$t('alert_title')"></div>
				<div class="fs14">{{ $t('alert_text') }}</div>
			</div>
		</section>
		<section class="floor5">
			<ScreenIntersectionObserver :adapter="designTopImgAdapter"
										style="position: absolute;top:-2rem;height: 2rem;width: 100%"
										:crossScreenPositionY="100">
				<template v-slot:default="{distance}">
					<img ref="designTopImg" src="../../../src/assets/imgs/home/design_top.png"
						 :style="{transform:`translateY(${distance}px)`}" alt="" class="top">
				</template>
			</ScreenIntersectionObserver>
			<div class="text max-w250">
				<div class="fs22 pb16 lh1x4 fw700" v-html="$t('design_title')"></div>
				<div class="fs14">{{ $t('design_text') }}</div>
			</div>
			<ScreenIntersectionObserver :adapter="designBottomImgAdapter"
										style="position: absolute;bottom:-2.1rem;height: 2rem;width: 100%"
										:crossScreenPositionY="1000">
				<template v-slot:default="{distance}">
					<img ref="designBottomImg" src="../../../src/assets/imgs/home/design_bottom.png"
						 :style="{transform:`translateY(${-distance}px)`}" alt="" class="bottom">
				</template>
			</ScreenIntersectionObserver>
		</section>
		<section class="floor6 pt40 pb40">
			<img src="../../../src/assets/imgs/home/spec_m.png" alt="" class="max-w250 mb24">
			<img v-if="this.$i18n.locale==='zh-CN'" src="../../../src/assets/imgs/home/spec_detail_m.jpg" alt=""
				 class="spec-detail mb40">
			<img v-if="this.$i18n.locale==='en-US'" src="../../../src/assets/imgs/home/spec_detail_en_m.jpg" alt=""
				 class="spec-detail-en mb40">
		</section>
		<section class="floor8">
			<h3 class="title fs22 fw400 mb16 white">{{ $t('coverage') }}</h3>
			<table class="region-table white fs14">
				<tr v-for="rowName in Object.keys(_coverageRegionTable)" :key="rowName">
					<td v-for="(rowVal,index) in _coverageRegionTable[rowName]" :key="index">{{rowVal.countryName}}</td>
				</tr>
			</table>
		</section>
		<section class="floor7">
			<img src="../../assets/imgs/home/mtrack_top_m.png" alt="" class="app-pic-top h80 mb100">
			<div class="app-title max-w300">
				<div class="fs22 lh1x4 fw700 pb16" v-html="$t('app_title')"></div>
				<div class="fs14">{{ $t('app_text')}}</div>
			</div>
			<div class="app-content">
				<div class="describe">
					<div class="slide-icon">
						<img class="w46" v-if="activeIndex===0" src="../../assets/imgs/home/ic_map.png"
							 alt="">
						<img class="w46" v-if="activeIndex===1" src="../../assets/imgs/home/ic_region.png" alt="">
						<img class="w46" v-if="activeIndex===2" src="../../assets/imgs/home/ic_share.png" alt="">
						<img class="w46" v-if="activeIndex===3" src="../../assets/imgs/home/ic_locate.png" alt="">
						<img class="w46" v-if="activeIndex===4" src="../../assets/imgs/home/ic_alert.png" alt="">
					</div>
					<div class="fs20 lh1x4 fw700 pb8" v-if="activeIndex===0" v-html="$t('app_slide_title_0')"></div>
					<div class="fs14" v-if="activeIndex===0" v-html="$t('app_slide_text_0')"></div>
					<div class="fs20 lh1x4 fw700 pb8" v-if="activeIndex===1" v-html="$t('app_slide_title_1')"></div>
					<div class="fs14" v-if="activeIndex===1" v-html="$t('app_slide_text_1')"></div>
					<div class="fs20 lh1x4 fw700 pb8" v-if="activeIndex===2" v-html="$t('app_slide_title_2')"></div>
					<div class="fs14" v-if="activeIndex===2">{{ $t('app_slide_text_2') }}</div>
					<div class="fs20 lh1x4 fw700 pb8" v-if="activeIndex===3" v-html="$t('app_slide_title_3')"></div>
					<div class="fs14" v-if="activeIndex===3">{{ $t('app_slide_text_3') }}</div>
					<div class="fs20 lh1x4 fw700 pb8" v-if="activeIndex===4" v-html="$t('app_slide_title_4')"></div>
					<div class="fs14" v-if="activeIndex===4">
						<div class="text-slide-4">
							<div class="pr4" v-if="activeIndex===4">•</div>
							<div v-if="activeIndex===4">{{ $t('app_slide_text_4_1') }}</div>
						</div>
						<div class="text-slide-4 pt8">
							<div class="pr4" v-if="activeIndex===4">•</div>
							<div v-if="activeIndex===4">{{ $t('app_slide_text_4_2') }}</div>
						</div>
					</div>
				</div>
				<div class="slide">
					<div class="slide-frame">
						<div class="mockup">
							<div class="mockup-in-shadow-2">
								<div class="mockup-in-shadow-1"></div>
							</div>
						</div>
						<div class="swiper-container" ref="pcSwiperWrapper">
							<div class="swiper-wrapper">
								<!-- Slides -->
								<img class="swiper-slide" v-if="this.$i18n.locale==='zh-CN'"
									 src="../../../src/assets/imgs/home/slide_0.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='en-US'"
									 src="../../../src/assets/imgs/home/slide_0_en.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='zh-CN'"
									 src="../../../src/assets/imgs/home/slide_1.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='en-US'"
									 src="../../../src/assets/imgs/home/slide_1_en.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='zh-CN'"
									 src="../../../src/assets/imgs/home/slide_2.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='en-US'"
									 src="../../../src/assets/imgs/home/slide_2_en.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='zh-CN'"
									 src="../../../src/assets/imgs/home/slide_3.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='en-US'"
									 src="../../../src/assets/imgs/home/slide_3_en.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='zh-CN'"
									 src="../../../src/assets/imgs/home/slide_4.jpg" alt="">
								<img class="swiper-slide" v-if="this.$i18n.locale==='en-US'"
									 src="../../../src/assets/imgs/home/slide_4_en.jpg" alt="">
							</div>
						</div>
					</div>
					<div class="swiper-btn">
						<div class="swiper-button-prev"></div>
						<div class="swiper-button-next"></div>
					</div>
				</div>
				<div class="swiper-pagination"></div>
				<div class="download">
					<div class="tag-store">
						<a href="https://ifreemogos.com/mtrack">
							<img src="../../../src/assets/imgs/home/app_store.png" alt="" class="tag-size mt8 mb8">
						</a>
						<a href="https://ifreemogos.com/mtrack">
							<img src="../../../src/assets/imgs/home/play_store.png" alt="" class="tag-size">
						</a>
					</div>
				</div>
			</div>
		</section>
		<div :class="['coupon',couponVisibale?'coupon-show':couponFirstVisibale?'coupon-show-first':'coupon-hidden']">
			<a @click="clickCouponHandle" href="https://store.ifreegroup.com/collections/mogo/products/mogo-t1"
			   target="_blank">
				<img v-if="this.$i18n.locale==='en-US'" src="../../../src/assets/imgs/home/coupon_t1_en.png" alt="" style="width: 203px; height: 288px;">
				<img v-if="this.$i18n.locale==='zh-CN'" src="../../../src/assets/imgs/home/coupon_t1_cn.png" alt="" style="width: 203px; height: 288px;">
			</a>
		</div>
	</Layout>
</template>

<script>
	(function () {
		const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
		if (window.ShopifyBuy) {
			if (window.ShopifyBuy.UI) {
				ShopifyBuyInit();
			} else {
				loadScript();
			}
		} else {
			loadScript();
		}

		function loadScript() {
			var script = document.createElement('script');
			script.async = true;
			script.src = scriptURL;
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
			script.onload = ShopifyBuyInit;
		}

		function ShopifyBuyInit() {
			// eslint-disable-next-line no-undef
			var client = ShopifyBuy.buildClient({
				domain: 'ifree-store.myshopify.com',
				storefrontAccessToken: 'b570275f91a1ef4970a0bffc19e9a292',
			});
			// eslint-disable-next-line no-undef
			ShopifyBuy.UI.onReady(client).then(function (ui) {
				ui.createComponent('product', {
					id: '4733696016519',
					node: document.getElementById('product-component-1595415704699'),
					moneyFormat: '%24%7B%7Bamount%7D%7D',
					options: {
						'product': {
							'styles': {
								'product': {
									'@media (min-width: 601px)': {
										'max-width': 'calc(25% - 20px)',
										'margin-left': '20px',
										'margin-bottom': '50px'
									}
								},
								'title': {
									'font-family': 'Montserrat, sans-serif'
								},
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								},
								'price': {
									'font-family': 'Montserrat, sans-serif'
								},
								'compareAt': {
									'font-family': 'Montserrat, sans-serif'
								},
								'unitPrice': {
									'font-family': 'Montserrat, sans-serif'
								}
							},
							'buttonDestination': 'checkout',
							'contents': {
								'img': false,
								'title': false,
								'price': false
							},
							'text': {
								'button': 'Buy now'
							},
							'googleFonts': [
								'Montserrat'
							]
						},
						'productSet': {
							'styles': {
								'products': {
									'@media (min-width: 601px)': {
										'margin-left': '-20px'
									}
								}
							}
						},
						'modalProduct': {
							'contents': {
								'img': false,
								'imgWithCarousel': true,
								'button': false,
								'buttonWithQuantity': true
							},
							'styles': {
								'product': {
									'@media (min-width: 601px)': {
										'max-width': '100%',
										'margin-left': '0px',
										'margin-bottom': '0px'
									}
								},
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								}
							},
							'googleFonts': [
								'Montserrat'
							],
							'text': {
								'button': 'Add to cart'
							}
						},
						'cart': {
							'styles': {
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								}
							},
							'text': {
								'total': 'Subtotal',
								'button': 'Checkout'
							},
							'googleFonts': [
								'Montserrat'
							]
						},
						'toggle': {
							'styles': {
								'toggle': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									'background-color': '#1359c2',
									':hover': {
										'background-color': '#1150af'
									},
									':focus': {
										'background-color': '#1150af'
									}
								}
							},
							'googleFonts': [
								'Montserrat'
							]
						}
					},
				});
			});
		}
	})();

	import Swiper from 'swiper';
	import ScreenIntersectionObserver from '@/components/ScreenIntersectionObserver';
	import BezierEasing from 'bezier-easing';
	import {fetchCoverageRegionApi} from '@/api/common';
	import {exchangeListToTable} from '@/views/Home/apiDataConversion';
	import Header from '@/components/common/Header/Index.vue';
	import copy from 'copy-to-clipboard';

	const easing = BezierEasing(0.27, 0.04, 0.40, 0.62);
	export default {
		components: {
			ScreenIntersectionObserver,
			Header
		},
		data() {
			return {
				activeIndex: 0,
				coverageRegionList: [],
				couponVisibale: false,
				couponFirstVisibale: false,
				showNavBar: true,
			};
		},
		mounted() {
			// 取消浏览器记录滚动条位置
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}
			this.fetchCoverageRegion();
			this.initSwiper();
			window.addEventListener('scroll',this.onScrolling);
			this.initIntersectionObserver();
		},
		methods: {
			clickCouponHandle(e){
				if(!this.couponVisibale){
					e.preventDefault();
					this.couponVisibale = true;this.couponFirstVisibale = true;
				}
				copy('T1PROMO20');
			},
			navToIfreeGroupPage() {
				// https://faq.ifreegroup.cn/?type=tracker&lang=$_lang
				// window.location.href = `https://faq.ifreegroup.cn/?type=tracker&lang=${this.$i18n.locale}`;
				window.open(`https://faq.ifreegroup.cn/?type=tracker&lang=${this.$i18n.locale}`);
			},
			async fetchCoverageRegion() {
				const {data} = await fetchCoverageRegionApi();
				this.coverageRegionList = data;
			},
			onScrolling(e){
				let scrollTop = document.documentElement.scrollTop;
				let targetHeight = 3150;
				if(scrollTop >= targetHeight && scrollTop <= (targetHeight + 120)){
					this.couponFirstVisibale = true;
					this.couponVisibale = true;
				}else{
					this.couponVisibale = false;
				}
				// 当前为向上方向
				let isUpDirect = (Number(this.lastPostiionYVal) - scrollTop) > 0 ;
				if(isUpDirect){
					this.showNavBar = true;
				}else{
					if(scrollTop >= 300){
						this.showNavBar = false;
					}else{
						this.showNavBar = true;
					}
				}
				this.lastPostiionYVal = scrollTop;

			},
			initIntersectionObserver() {
				const iov = new IntersectionObserver((entries) => {
					entries.forEach(item => {
						if (item.isIntersecting) {
							if (item.target === this.$refs.earthImg) {
								item.target.classList.add('animated', 'slideInUp');
							} else if (item.target === this.$refs.gpsBgImg) {
								item.target.classList.add('animated', 'slideInUp');
							}
						}
					});
				});
				// 添加被观察的对象
				[
					this.$refs.earthImg,
					this.$refs.gpsBgImg,
				].forEach(item => {
					iov.observe(item);
				});
			},
			initSwiper() {
				const that = this;
				new Swiper(this.$refs.pcSwiperWrapper, {
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: true,
					},
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					pagination: {
						el: '.swiper-pagination',
					},
					on: {
						slideChange: function () {
							// https://github.com/nolimits4web/swiper/issues/2629#issuecomment-527504478
							if (that.swiper !== null) {
								that.swiper.loopDestroy();
								that.swiper.loopCreate();
							}
							that.activeIndex = this.realIndex;
						},
					},
				});
			},
			designTopImgAdapter({distance}) {
				return distance * 0.8;
			},
			designBottomImgAdapter({eleHeight, distance}) {
				return easing(distance / eleHeight) * distance;
			}
		},
		computed: {
			_coverageRegionTable() {
				return exchangeListToTable(this.$i18n.locale, this.coverageRegionList, 2);
			}
		},
		destroyed(){
			window.removeEventListener('scroll',this.onScrolling);
		}
	};
</script>

<style>
	body {
		line-height: 180%;
	}

	.swiper-pagination-bullet, .swiper-pagination-bullet-active {
		margin-right: 2px;
		margin-left: 2px;
	}

	@-webkit-keyframes slideInUp {
		from {
			-webkit-transform: translate3d(0, 100%, 0);
			transform: translate3d(0, 100%, 0);
			opacity: 0;
		}

		to {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}

	@keyframes slideInUp {
		from {
			-webkit-transform: translate3d(0, 100%, 0);
			transform: translate3d(0, 100%, 0);
			opacity: 0;
		}

		to {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}

	.slideInUp {
		-webkit-animation-name: slideInUp;
		animation-name: slideInUp;
		animation-delay: 0.5s;
	}

</style>
<style lang="scss" scoped>

	.HomeMobile{
		:deep  .nav-header{
			transition: all 0.3s;
		}
		:deep  .nav-header-show{
			opacity: 1;
		}
		:deep  .nav-header-hidden{
			opacity: 0;
		}
	}


	.to-top {
		position: fixed;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		border-radius: 80px;
		bottom: 48px;
		right: 16px;
		z-index: 999;
		background: linear-gradient(to bottom, #1A77FF, #47CCFF);
		color: white;
		/*box-shadow: 0 14px 18px rgba(130, 210, 255, .5);*/
		&:hover {
			background: linear-gradient(to bottom, #1a6eff, #47c2ff);
			color: white;
		}
	}

	.faq {
		position: fixed;
		bottom: 108px;
		right: 16px;
		width: 48px;
		height: 48px;
		border-radius: 80px;
		z-index: 999;
		background: linear-gradient(to bottom, #1A77FF, #47CCFF);
		color: white;
		/*box-shadow: 0 14px 18px rgba(130, 210, 255, .5);*/
		&:hover {
			background: linear-gradient(to bottom, #1a6eff, #47c2ff);
			color: white;
		}
	}

	.white {
		color: white;
	}

	.picBorderRadius {
		border-radius: 12px;
	}

	.lh1x4 {
		line-height: 140%;
	}

	.w360 {
		width: 3.60rem;
	}

	.w210 {
		width: 2.10rem;
	}

	.w540 {
		width: 5.40rem;
	}

	.h325 {
		height: 3.25rem;
	}

	.max-w250 {
		max-width: 2.50rem;
	}

	.max-w300 {
		max-width: 3.00rem;
	}

	.max-w480 {
		max-width: 4.80rem;
	}

	.max-w700 {
		max-width: 7.00rem;
	}

	.max-w800 {
		max-width: 8.00rem;
	}

	.floor0, .floor1, .floor3, .floor4, .floor5, .floor6 {
		color: #fff;
	}

	.floor0 {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		min-height: 6.67rem;
		background: url("../../../src/assets/imgs/home/header_bg_m.jpg") 50% no-repeat;
		background-size: cover;

		.shine-1 {
			position: absolute;
			top: 6%;
			left: 14%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-2 {
			position: absolute;
			top: 40%;
			right: 8%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-3 {
			position: absolute;
			bottom: 6%;
			right: 12%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-point {
			width: 5px;
			height: 5px;
			border-radius: 6px;
			background: #00BFFF;
			box-shadow: 0 0 12px 1px #00BFFF;
		}

		.anim-shine {
			animation: 2s shine 0s infinite;
			-webkit-animation: 2s shine 0s infinite;
			-moz-animation: 2s shine 0s infinite;
			@keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
			@-webkit-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}

			@-moz-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
		}

		.anim-shine-2 {
			animation: 2s shine 1s infinite;
			-webkit-animation: 2s shine 1s infinite;
			-moz-animation: 2s shine 1s infinite;
			@keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
			@-webkit-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}

			@-moz-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
		}

		.video-tracker {
			border-radius: 6px;
			margin-top: 100px;
			z-index: 998;
		}

	}

	.floor1 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 6.40rem;
		background-color: #000;

		.locate-pic {
			width: 100%;
		}
	}

	.floor2 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #fff;

		.content {
			align-items: center;
			justify-content: center;
			text-align: center;
		}

		.pic-gps {
			height: 300px;
			width: 3.75rem;
			overflow: hidden;
			padding-top: 40px;
		}

		.gps-bg {
			position: relative;
			left: -40%;
			height: 4.00rem;
		}
	}

	.floor3 {
		display: flex;
		flex-direction: column;
		align-items: center;
		/*justify-content: center;*/
		width: 3.75rem;
		height: 6.67rem;
		background: url("../../../src/assets/imgs/home/bluetooth_bg_m.jpg");
		background-size: cover;

		.content {
			align-items: center;
			justify-content: center;
			text-align: center;
		}
	}

	.floor4 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 6.30rem;
		background: url("../../../src/assets/imgs/home/family_m.jpg") 50% no-repeat;
		background-size: cover;
	}

	.floor5 {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 6.67rem;
		overflow: hidden;

		.top {
			/*position: absolute;*/
			width: 2.00rem;
			left: 0;
			right: 0;
			margin-right: 1.2rem;
		}

		.text {
			text-align: left;
		}

		.bottom {
			/*position: absolute;*/
			width: 2.00rem;
			left: 0;
			right: 0;
			margin-top: .4rem;
			margin-left: 1.2rem;
		}
	}

	.floor6 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #000;

		.spec-detail {
			width: 3.15rem;
		}

		.spec-detail-en {
			width: 3.23rem;
		}
	}

	.floor7 {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		background-color: #f4f4f4;

		.app-pic-top {
			position: absolute;
			top: 0;
			right: 0;
		}

		.app-title {
			margin-top: 1.20rem;
		}

		.app-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-bottom: .50rem;
		}

		.describe {
			display: flex;
			flex-direction: column;
			width: 3.3rem;
			min-height: 2.0rem;
			justify-content: center;

			.text-slide-4 {
				display: flex;
				text-align: left;
			}
		}

		.slide {
			position: relative;

			.slide-frame {

				.mockup {
					/*background: linear-gradient(to left, #f0f0f0, #f5f5f5);*/
					border-radius: .2rem;
					box-shadow: 12px 14px 23px rgba(0, 0, 0, 0.1);

					.mockup-in-shadow-2 {
						border-radius: .2rem;
						box-shadow: inset -1px -1px 5px rgba(0, 0, 0, 0.2);

						.mockup-in-shadow-1 {
							width: 2.32rem;
							height: 4.8rem;
							border-radius: .2rem;
							box-shadow: inset 3px 4px 4px #fff;
						}
					}
				}

				.swiper-container {
					position: absolute;
					top: .10rem;
					left: .10rem;
					width: 2.10rem;
					height: 4.58rem;
					overflow: hidden;
					border-radius: .12rem;
					box-shadow: 0 0 .02rem rgba(0, 0, 0, 0.1);
				}
			}

			.swiper-btn {
				position: absolute;
				top: 2rem;
				right: -.7rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 3.7rem;
				--swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
				--swiper-navigation-size: 10px; /* 设置按钮大小 */
				:focus {
					-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
					outline: none;
				}

				.swiper-button-prev {
					position: relative;
					height: .4rem;
					width: .4rem;
					background-color: #ccc;
					border-radius: .2rem;

					::after {
						font-size: 18px !important;
					}
				}

				.swiper-button-next {
					position: relative;
					height: .4rem;
					width: .4rem;
					background-color: #ccc;
					border-radius: .2rem;
				}
			}
		}

		.swiper-pagination {
			position: relative;
			margin-top: .14rem;
			width: 2.40rem;
			--swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
			--swiper-navigation-size: 10px; /* 设置按钮大小 */
			:focus {
				-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
				outline: none;
			}
		}

		.download {
			display: flex;
			align-items: center;
			margin-top: .24rem;

			.tag-store {
				display: flex;
				flex-direction: column;

				.tag-size {
					width: 1.6rem;
				}
			}
		}
	}

	.floor8 {
		padding: 0 24px;
		margin-bottom: 40px;

		.title {
			text-align: left;
		}

		.region-table {
			width: 100%;

			td {
				text-align: left;
				width: 50%;
				padding: 4px 0;
			}
		}
	}

	.coupon{
		position: fixed;
		top: 2.3rem;
		transition: right 500ms;
		-webkit-transition: right 500ms;
		-moz-transition: right 500ms;
		-o-transition: right 500ms;

		img{
			width: 203px;
			height: 288px;
		}
	}
	.coupon-show{
		right: 0;
	}
	.coupon-show-first{
		right: -185px;
	}
	.coupon-hidden{
		right: -210px;
	}
</style>
